import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { AuthShell, FormInput, PrimaryButton, ErrorBanner, SuccessBanner } from "@/components/auth/AuthShell";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setMsg("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message || "If that email exists, a reset link has been generated.");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Account recovery"
      title="Reset your password"
      footer={
        <Link to="/login" className="text-[#D4AF37] hover:underline" data-testid="back-to-login">← Back to sign in</Link>
      }
    >
      <p className="text-[#A0A0A0] -mt-4 mb-6 text-sm leading-relaxed">
        Enter your email and we'll generate a reset link.
        <br /><span className="text-[#D4AF37]/80 text-xs uppercase tracking-wider mt-2 inline-block">Note: email delivery isn't connected yet — the reset link prints to the backend console for now.</span>
      </p>
      <form onSubmit={onSubmit} data-testid="forgot-form">
        <ErrorBanner message={error} />
        <SuccessBanner message={msg} />
        <FormInput label="Email" type="email" value={email} onChange={setEmail} placeholder="you@business.com" required testId="forgot-email-input" />
        <PrimaryButton disabled={loading} testId="forgot-submit-button">
          {loading ? "Sending…" : "Generate Reset Link"}
        </PrimaryButton>
      </form>
    </AuthShell>
  );
}
